import { useMonyawn } from "../context/MonyawnContext";

export function useReleaseReviewOps() {
  const { patchState } = useMonyawn();

  const removeReleaseProofReview = (reviewId: string) => {
    patchState(
      (current) => ({
        ...current,
        releaseProofReviews: current.releaseProofReviews.filter(
          (item) => item.review_id !== reviewId,
        ),
      }),
      "Stored release/readiness review removed.",
    );
  };

  const toggleReleaseProofReviewPin = (reviewId: string) => {
    patchState(
      (current) => ({
        ...current,
        releaseProofReviews: current.releaseProofReviews.map((item) =>
          item.review_id === reviewId ? { ...item, pinned: !item.pinned } : item,
        ),
      }),
      "Stored release/readiness review pin state updated.",
    );
  };

  const clearReleaseProofReviewsForCurrentOpportunity = (
    selectedAccountId: string,
    selectedOpportunityId: string,
  ) => {
    patchState(
      (current) => ({
        ...current,
        releaseProofReviews: current.releaseProofReviews.filter(
          (item) =>
            !(
              item.account_id === selectedAccountId && item.opportunity_id === selectedOpportunityId
            ),
        ),
      }),
      "Stored release/readiness reviews cleared for the current opportunity.",
    );
  };

  return {
    removeReleaseProofReview,
    removeReleaseArtifactReview: removeReleaseProofReview,
    toggleReleaseProofReviewPin,
    toggleReleaseArtifactReviewPin: toggleReleaseProofReviewPin,
    clearReleaseProofReviewsForCurrentOpportunity,
    clearReleaseArtifactReviewsForCurrentOpportunity: clearReleaseProofReviewsForCurrentOpportunity,
  };
}
